import { RiBuilding2Line } from "react-icons/ri";

import { useGetWhoami } from "@/api/whoami/get-whoami";
import { routePaths } from "@/config/route-paths";

import { SideNavItemLink } from "./SideNavItemLink";

/**
 * テナント管理への導線。ホストだけに出す。
 *
 * API がホスト限定のため、admin / member に見せても 403 になるだけ。
 */
export const SideNavItemTenantManagement = () => {
  const { isHost } = useGetWhoami();

  if (!isHost) {
    return null;
  }

  return (
    <SideNavItemLink
      label="テナント管理"
      icon={<RiBuilding2Line size={20} className="text-[#F2F5FC]" />}
      href={routePaths.admin.tenants.getHref()}
    />
  );
};
